
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const categories = [
  { id: 'shop-classes', icon: 'ri-graduation-cap-line', label: 'Classes', count: 6, color: 'from-amber-400 to-yellow-300' },
  { id: 'shop-kits', icon: 'ri-box-3-line', label: 'Cocktail Kits', count: 5, color: 'from-rose-400 to-pink-300' },
  { id: 'shop-manuals', icon: 'ri-book-open-line', label: 'Manuals', count: 6, color: 'from-emerald-400 to-teal-300' },
  { id: 'shop-packages', icon: 'ri-gift-line', label: 'Packages', count: 5, color: 'from-amber-500 to-orange-400' },
];

export default function ShopHero() {
  const { ref, isVisible } = useScrollAnimation();

  const scrollToCategory = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="relative pt-28 pb-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/97547c9e85a3a3f35819edfe699a72c9.jpg"
          alt="Shop background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/90"></div>
      </div>

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-6 pt-12 pb-8">
        {/* Header */}
        <div className={`text-center mb-14 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-3 px-5 py-2 bg-amber-500/15 backdrop-blur-sm rounded-full border border-amber-500/20 mb-6">
            <i className="ri-store-2-line text-amber-400"></i>
            <span className="text-amber-300 text-xs font-semibold tracking-[0.2em] uppercase">Official Store</span>
          </div>
          <h1 className="text-5xl md:text-7xl font-display font-normal text-white mb-5">
            Shop <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300">Collection</span>
          </h1>
          <p className="text-white/50 max-w-2xl mx-auto text-lg leading-relaxed">
            Explore our curated selection of cocktail classes, premium kits, training manuals, and exclusive packages — everything you need to elevate your craft.
          </p>
        </div>

        {/* Category Quick Links */}
        <div className={`grid grid-cols-2 md:grid-cols-4 gap-4 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => scrollToCategory(cat.id)}
              className="group relative bg-white/[0.06] backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-amber-500/30 transition-all duration-300 cursor-pointer text-left overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-amber-500/10 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${cat.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-lg`}>
                <i className={`${cat.icon} text-xl text-stone-900`}></i>
              </div>
              <h3 className="text-white font-semibold text-base mb-1 group-hover:text-amber-200 transition-colors">{cat.label}</h3>
              <p className="text-white/40 text-sm">{cat.count} products</p>
              <i className="ri-arrow-down-line text-amber-400/50 absolute bottom-4 right-4 group-hover:translate-y-1 transition-transform"></i>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
